import React, { Fragment, PureComponent } from 'react'
import Immutable from 'immutable'

import appUrl, { openPost } from '@libs/appUrl'
import { InView } from 'react-intersection-observer'
import ArticleCard from '@components/ArticleCard'

import throttle from 'lodash/throttle'

import cx from 'classnames'
import styles from './MobileCarousel.scss'

import { ChevronRightIcon } from '@components/Icons'

class MobileCarousel extends PureComponent {
  static defaultProps = {
    className: '',
    isLoading: true,
    carousel: Immutable.fromJS([]),
  }

  constructor(props) {
    super(props)
    this.state = {
      initialIndex: 0,
    }
    // debounce
    this.handleOnChange = (index) => throttle(this._onChangeInView(index), 1000)
  }

  _onChangeInView = (index) => (inView) => {
    if (inView) this.setState((state) => ({ ...state, initialIndex: index }))
  }

  _onTitleBarClick = () => openPost(`${appUrl.hostUrl}/featured?titlebar=1`)

  renderCarousel() {
    const carousel = this.props.carousel.toJS()
    if (carousel.length === 0) return null
    return (
      <Fragment>
        <style jsx>{styles}</style>
        {carousel.map((article, index) => (
          <InView key={article.postID} threshold={0.95} onChange={this.handleOnChange(index)}>
            {({ ref }) => (
              <div ref={ref} className={cx('item', { active: index === this.state.initialIndex })}>
                <ArticleCard
                  className="MobileCarousel"
                  key={`MobileCarousel-${article.postID}`}
                  article={article}
                />
              </div>
            )}
          </InView>
        ))}
      </Fragment>
    )
  }

  render() {
    const { className } = this.props
    const classNames = cx('MobileCarousel', className)
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <div className={classNames}>
          <div className="title">
            <span>PopDaily 官方文章</span>
            <a className="link" onClick={this._onTitleBarClick}>
              <span>看更多文章</span>
              <ChevronRightIcon className="arrow" width="16" height="16" />
            </a>
          </div>
          <div className="content">{this.renderCarousel()}</div>
        </div>
      </Fragment>
    )
  }
}

export default MobileCarousel
